// extracted by css-extract-rspack-plugin
export default {"root":"root-zL6yVs","item":"item-vnuF8Z","fullWidth":"fullWidth-kOgl0H","centered":"centered-A8ly4Q"};